import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/orderManagement",
  name: "orderManagement",
  redirect: {
    name: "orderManagement",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/orderManagement/createOrder",
      name: "createOrder",
      meta: {
        title: "新建工单",
      },
      component: () => import("@/pages/orderManagement/createOrder/index.vue"),
    },
    {
      path: "/orderManagement/handlePage",
      name: "handlePage",
      meta: {
        title: "工单办理", // 统一的办理页面
        // cache: true,
      },
      component: () => import("@/pages/components/handlePage/index.vue"),
    },
    {
      path: "/orderManagement/showInfoOrder/:orderId",
      name: "showInfoOrder",
      meta: {
        title: "工单详情",
        // cache: true, 不可以缓存，不然打开的详情都是同一个
      },
      component: () =>
        import("@/pages/orderManagement/showInfoOrder/index.vue"),
    },
    {
      path: "/orderManagement/todoOrder",
      name: "todoOrder",
      meta: {
        ...meta,
        title: "待办工单",
      },
      component: () => import("@/pages/orderManagement/todoOrder/index.vue"),
    },
    {
      path: "/orderManagement/allOrder",
      name: "allOrder",
      meta: {
        title: "全部工单",
        cache: true,
      },
      component: () => import("@/pages/orderManagement/allOrder/index.vue"),
    },
    {
      path: "/orderManagement/doneOrder",
      name: "doneOrder",
      meta: {
        title: "已办工单",
        cache: true,
      },
      component: () => import("@/pages/orderManagement/doneOrder/index.vue"),
    },
    {
      path: "/orderManagement/stagingOrder",
      name: "stagingOrder",
      meta: {
        title: "暂存工单",
        cache: true,
      },
      component: () => import("@/pages/orderManagement/stagingOrder/index.vue"),
    },
    {
      path: "/orderManagement/toSignOrder",
      name: "toSignOrder",
      meta: {
        title: "待签收工单",
      },
      component: () => import("@/pages/orderManagement/toSignOrder/index.vue"),
    },
    {
      path: "/orderManagement/dissatisfiedOrder",
      name: "dissatisfiedOrder",
      meta: {
        title: "不满意工单",
        cache: true,
        keepAlive: true, // 开启缓存
      },
      component: () =>
        import("@/pages/orderManagement/dissatisfiedOrder/index.vue"),
    },
    {
      path: "/orderManagement/invalidOrder",
      name: "invalidOrder",
      meta: {
        title: "无效工单",
        cache: true,
      },
      component: () => import("@/pages/orderManagement/invalidOrder/index.vue"),
    },
    {
      path: "/orderManagement/departmentOrder",
      name: "departmentOrder",
      meta: {
        title: "部门工单",
        cache: true,
      },
      component: () =>
        import("@/pages/orderManagement/departmentOrder/index.vue"),
    },
    {
      path: "/orderManagement/collected",
      name: "collected",
      meta: {
        title: "收藏工单",
        cache: true,
      },
      component: () => import("@/pages/orderManagement/collected/index.vue"),
    },
    {
      path: "/orderManagement/gtmOrder",
      name: "gtmOrder",
      meta: {
        title: "赣通码工单",
      },
      component: () => import("@/pages/orderManagement/gtmOrder/index.vue"),
    },
    {
      path: "/orderManagement/missedCallsOrder",
      name: "missedCallsOrder",
      meta: {
        title: "未接来电工单",
      },
      component: () =>
        import("@/pages/orderManagement/missedCallsOrder/index.vue"),
    },
    {
      path: "/orderManagement/recordingAssociations",
      name: "recordingAssociations",
      meta: {
        title: "录音关联",
      },
      component: () =>
        import("@/pages/orderManagement/recordingAssociations/index.vue"),
    },
    {
      path: "/orderManagement/delayOrder",
      name: "delayOrder",
      meta: {
        title: "延期申请审批",
      },
      component: () => import("@/pages/orderManagement/delayOrder/index.vue"),
    },
    {
      path: "/orderManagement/postponeOrder",
      name: "postponeOrder",
      meta: {
        title: "延期申请工单",
      },
      component: () =>
        import("@/pages/orderManagement/postponeOrder/index.vue"),
    },
    {
      path: "/orderManagement/delayHandlePage",
      name: "delayHandlePage",
      meta: {
        title: "延时工单办理", // 统一的办理页面
      },
      component: () => import("@/pages/components/delayHandlePage/index.vue"),
    },
    {
      path: "/orderManagement/supervisingOrder",
      name: "supervisingOrder",
      meta: {
        title: "督办工单",
        cache: true,
      },
      component: () =>
        import("@/pages/orderManagement/supervisingOrder/index.vue"),
    },
    {
      path: "/orderManagement/approveOrder",
      name: "approveOrder",
      meta: {
        title: "待批示工单",
        cache: true,
      },
      component: () => import("@/pages/orderManagement/approveOrder/index.vue"),
    },
    {
      path: "/orderManagement/problemOrder",
      name: "problemOrder",
      meta: {
        title: "疑难工单",
        cache: true,
      },
      component: () => import("@/pages/orderManagement/problemOrder/index.vue"),
    },
    {
      path: "/orderManagement/trackingOrder",
      name: "trackingOrder",
      meta: {
        title: "工单追踪",
        cache: true,
      },
      component: () =>
        import("@/pages/orderManagement/trackingOrder/index.vue"),
    },
    {
      path: "/orderManagement/sixOrder",
      name: "sixOrder",
      meta: {
        title: "六方联办工单",
      },
      component: () => import("@/pages/orderManagement/sixOrder/index.vue"),
    },
    {
      path: "/orderManagement/copyOrder",
      name: "copyOrder",
      meta: {
        ...meta,
        title: "抄送工单",
      },
      component: () => import("@/pages/orderManagement/copyOrder/index.vue"),
    },
  ],
};
